export interface TestimonialData {
  id: number;
  name: string;
  text: string[];
}

const testimonialsData: TestimonialData[] = [
  {
    id: 1,
    name: 'מ. מנהל חנות כל בו בבית שמש',
    text: [
      'כמנהל חנות אני מכיר הרבה מכונות תספורת,',
      'וחשבתי שמדובר בעוד גימיק.',
      'אך אחרי שהשתמשתי ראיתי שזה הדבר!',
      'סיפרתי את ילדיי והסכין נוחה ללא תלונה אחת!',
      'השיער לא מציק בצוואר, והרצפה? נקיה!'
    ],
  },
  {
    id: 2,
    name: 'י. א. אב לילד רגיש',
    text: [
      'יש לי בן שרגיש מאוד למגע,',
      ' תמיד פעולת התספורת הייתה ממש מייגעת,',
      'ואחרי שקנינו את המכונה הילד רק מחכה להסתפר ולראות את השיער הקצוץ בתוך המכונה.'
    ],
  },
  {
    id: 3,
    name: 'א. מירושלים, אם למספר ילדים',
    text: [
      'הבן שלי ביקש שנקנה את המכונה החדשה,',
      ' עד שלא ניסינו לא האמנו לפלא,',
      'ממש שערות בודדות על הרצפה,',
      'אני לא נאבקת יותר בניקיון ובשיער שנדבק על המגבות, על הבגדים ומה לא, ממליצה בחום!'
    ],
  },
  {
    id: 4,
    name: 'י. מנהל קופת צדקה ארצית',
    text: [
      'רכשתי כמות של מכונות עבור נציגי קופת הצדקה,',
      'כמובן שקודם ניסיתי על ילדי,', 
     ' ונפעמתי מרמת הניקיון והנעימות.',
      'קיבלתי פידבקים מרוצים מאוד מהנציגים, ',
      'פשוט מתנה שימושית ומוצלחת.'
    ],
  },
  {
    id: 5,
    name: 'ז. ט. מביתר',
    text: [
      'קניתי את המכונה, לאחר פעם פעמיים שהשתמשתי בה, קלטתי איך עובדים איתה,',
      'ואני חושב שאין סיבה לקנות מכונה ללא שאיבה,',
      'בשביל מה להישאר עם כל הלכלוך והעיקצוץ?!',
      'אני ממש ממליץ עליה לחברים ומכרים שלי.'
    ],
  },
];

export default testimonialsData;

